import { Grid } from "@material-ui/core";
import { StepTitle } from "../../components/stepTitle";
import { OneToolCardBorder } from "../common/oneToolCard";
import { PortfolioInformationForm } from "./forms/portfolioInformationForm";

export const PortfolioInformationStep = () => {
  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <StepTitle
          title={<>Portfolio Information</>}
          subtitle={
            <>
              Please fill out the following information for the property that
              will be used on the quote.
            </>
          }
        />
      </Grid>
      <Grid item xs={12}>
        <PortfolioInformationForm />
      </Grid>
    </Grid>
  );
};